export default __webpack_public_path__ + "static/media/outdoorGarden.fcba3f5c.jpg";